export default __webpack_public_path__ + "static/media/notificationsIcon.b075aa58.png";